<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :search-input.sync="search"
    prepend-inner-icon="mdi-magnify"
    append-icon=""
    color="grey"
    hide-details
    ref="searchtext"
    :item-text="text"
    :item-value="keytext"
    :label="$t('searchMatches')"
    no-filter
    dark
    dense
    solo-inverted
    clearable
    @change="showEvent"
    :loading="loading"
    class="search-autocomplete"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          {{ $t('searchByTeamOrQbet') }}
        </v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:selection="{ attr, on, item, selected }">
      <span v-text="item.title"></span>
    </template>
    <template v-slot:item="{ item, index }">
      <v-list-item-content>
        <v-list-item-title v-text="item.title"></v-list-item-title>
        <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-list-item-subtitle
          v-text="
            new Date(item.scheduled).toLocaleDateString(getLanguage, options)
          "
        ></v-list-item-subtitle>
        <v-list-item-subtitle
          v-text="
            new Date(item.scheduled).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })
          "
        ></v-list-item-subtitle>
      </v-list-item-action>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'Search',
  data: () => ({
    isLoadingSearch: false,
    items: [],
    model: null,
    search: null,
    select: null,
    favourites: [],
    foundFavourites: [],
    loading: false,
    options: { year: 'numeric', month: 'long', day: 'numeric' },
  }),

  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getGameConsole: 'settings/getGameConsole',
    }),
  },

  methods: {
    ...mapActions({
      setLoadingPreview: 'odds/setLoadingPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      findEvent: 'tree/findEvent',
      fetchAntepost: 'odds/fetchAntepost',
    }),
    text(item) {
      return (
        item.title +
        ' — ' +
        item.source +
        ' - ' +
        item.competitors +
        ' ' +
        item.tournament
      )
    },
    keytext(item) {
      return (
        item.source +
        '#' +
        item.type +
        '#' +
        item.sport +
        '#' +
        item.category +
        '#' +
        item.tournament
      )
    },
    querySelections: debounce(function (v) {
      this.loading = true

      if (v && v.length >= 3) {
        this.findEvent({ lang: this.getLanguage, search: v }).then(response => {
          this.items = response
          this.loading = false
        })
      } else {
        this.loading = false
        return
      }
      if (v <= 2) {
        this.loading = false
        this.select = null
      }
    }, 300),
    async showEvent() {
      this.loading = false
      const sourceSplit = this.select.split('#')
      if (!_.isUndefined(this.select)) {
        await this.setLoadingPreview({ status: true })
        if (sourceSplit[1] == 'match') {
          let group = 0

          if (this.getGameConsole === 'marketview') {
            group = null
          }

          await this.fetchEventDetail({
            source: +sourceSplit[0],
            group: group,
            sport: +sourceSplit[2],
            tournament: +sourceSplit[4],
            status: 1,
          })
        } else if (sourceSplit[1] == 'antepost') {
          await this.fetchAntepost({
            idEvent: +sourceSplit[0] + '#antepost',
            type: 'antepost',
            source: +sourceSplit[0],
          })
        }
        this.$refs.searchtext.blur()
        await this.setLoadingPreview({ status: false })
        this.$root.$emit('close_search', true)
      }
    },
  },
  watch: {
    search(val) {
      if (_.isNull(val) && val == 'null' && val.length < 3) {
        return
      }
      this.querySelections(val)
    },
  },
}
</script>

<!--
<style scoped>
  #input-10{
    display: none;
  }
</style>-->
